export default __webpack_public_path__ + "static/media/document.6af95a15.svg";